import { useLK } from "@/controllerLK/LKstore";
import { toTimestamp } from "@/tools/date-time-tools";

export async function loadStat(dateFrom, dateTo, paramName, rubricIDs) {
  const lk = useLK();
  const params = new URLSearchParams();
  params.append("dateStart", toTimestamp(dateFrom));
  params.append("dateEnd", toTimestamp(dateTo));
  if (paramName && rubricIDs) {
    rubricIDs.forEach((id) => {
      params.append(paramName, id);
    });
  }
  return await this.loadCountryData({
    countryCode: lk.project.id,
    clear: true,
    params,
  });
}